module.exports = __webpack_public_path__ + "img/element_s.a8aa474c.png";